module.exports = __webpack_public_path__ + "static/img/banner.6985a394.png";